import { PATH_PRODUCTS_NEW, PATH_PRODUCTS_EDIT } from '../consts'
import { history } from '../redux/store'

type HistoryLocationOpts = Exclude<Parameters<typeof history.push>[0], string>

interface NavigateToProductEditOpts extends HistoryLocationOpts {
  productId?: string | number
  localizationId?: string
  preserveQueryParams?: boolean
}

export const navigateToProductEdit = ({
  productId,
  localizationId,
  preserveQueryParams = true,
  ...rest
}: NavigateToProductEditOpts) => {
  const search = preserveQueryParams ? history.location.search : undefined
  const productPath = productId ? `/${productId}` : ''
  const localizationPath = localizationId && productId ? `/localizations/${localizationId}` : ''
  const pathname = [PATH_PRODUCTS_EDIT, productPath, localizationPath].join('')

  history.push({
    pathname,
    search: search,
    ...rest,
  })
}

interface NavigateToProductCreateOpts extends HistoryLocationOpts {
  productId: string | number
  preserveQueryParams?: boolean
}

export const navigateToProductCreate = ({
  productId,
  preserveQueryParams = true,
  ...rest
}: NavigateToProductCreateOpts) => {
  const search = preserveQueryParams ? history.location.search : undefined
  const pathname = `${PATH_PRODUCTS_NEW}/${productId}`

  history.push({
    pathname,
    search: search,
    ...rest,
  })
}

interface NavigateToProductAliasRemapOpts extends HistoryLocationOpts {
  productId: string | number
  aliasId?: string | number
  returnUrl?: string
  preserveQueryParams?: boolean
}

export const navigateToProductAliasRemap = ({
  productId,
  aliasId,
  returnUrl,
  preserveQueryParams = true,
  ...rest
}: NavigateToProductAliasRemapOpts) => {
  const pathname = `/products/${productId}/aliases/remap`

  const searchParams = preserveQueryParams
    ? new URLSearchParams(history.location.search)
    : new URLSearchParams()

  if (aliasId) searchParams.set('aliasId', '' + aliasId)
  if (returnUrl) searchParams.set('returnUrl', returnUrl)

  const search = searchParams.toString()
  history.push({ pathname, search, ...rest })
}
